import { withInstall } from '@vuesax-plus/utils'
import OptionGroup from './src/option-group.vue'

export const VsOptionGroup = withInstall(OptionGroup)
export default VsOptionGroup

export * from './src/option-group'
